
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentValue: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getAllValues({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/AboutUs/GetAllValues`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_VALUES', response.data.data);
                return response.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setValues({ commit }, values) {
        try {
            await commit('SET_VALUES', values);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async addValue({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/AboutUs/AddValue`, value);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editValue({ commit }, value) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/AboutUs/UpdateValue`, value);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changeValueStatus({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/AboutUs/ChangeValueStatus`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentValueToView({ commit },value) {
        await commit('axiosStart');
        await commit('SET_CURRENT_VALUE',value);
        await commit('axiosSuccess');
        return true
    },
    

    //STORIES
    async getAllStories({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/AboutUs/GetAllStories`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_STORIES', response.data.data);
                return response.data
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setStories({ commit }, stories) {
        try {
            await commit('SET_STORIES', stories);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    
    async addStory({ commit }, story) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/AboutUs/AddStory`, story);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editStory({ commit }, story) {
    
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/AboutUs/UpdateStory`, story);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changeStoryStatus({ commit }, story) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/AboutUs/ChangeStoryStatus`,{},{
                id:story.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentStoryToView({ commit },story) {
        await commit('axiosStart');
        await commit('SET_CURRENT_STORY',story);
        await commit('axiosSuccess');
        return true
    },


};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
